export interface ProductImage {
  path: string;
}

export const productImageFromResponse = (responseData: any): ProductImage => ({
  path: responseData.path,
});
